module.exports = __webpack_public_path__ + "img/Orizuru_EN.8739bae2.png";